import React from 'react'
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom'
import './App.css'
import Navbar from './components/Navbar'
import Footer from './components/Footer'

import { About } from './components/pages/About'
import { WhatWeDo } from './components/pages/WhatWeDo'
import { Vision } from './components/pages/Vision'
import { Solution } from './components/pages/Solution'
import { Partners } from './components/pages/Partners'
import { Insights } from './components/pages/Insights'
import { Home } from './components/pages/Home'
import Contact from './components/pages/Contact'

const App = () => {
  return (
    <Router>
      <Navbar />
      <Switch>
        <Route path='/' exact component={Home} />
        <Route path='/about' component={About} />
        <Route path='/what-we-do' component={WhatWeDo} />
        <Route path='/vision' exact component={Vision} />
        <Route path='/solution' component={Solution} />
        <Route path='/partners' component={Partners} />
        <Route path='/insights' component={Insights} />
        <Route path='/contact' component={Contact} />
      </Switch>
      <Footer />
    </Router>
  )
}

export default App
